<ng-container [ngSwitch]="type">

  <collection-purpose-tasks *ngSwitchCase="purposeType.Tasks"
                            [collection]="collection"
                            [form]="form">
  </collection-purpose-tasks>

</ng-container>
